const clearScreen = (ctx) => {
  ctx.fillStyle = 'rgba(25,61,65,0.4)';
  ctx.fillRect(0, 0, 1152, 768);
};
export default clearScreen;
